import { PropsWithChildren, createContext } from "react";

import { ProjectRead } from "@nens/rana/api-v1";

export const ProjectContext = createContext<ProjectRead>({} as unknown as ProjectRead);

interface ProjectProviderProps {
  project: ProjectRead;
}

export function ProjectProvider({ project, children }: PropsWithChildren<ProjectProviderProps>) {
  return <ProjectContext.Provider value={project}>{children}</ProjectContext.Provider>;
}
